const e = "styles-module__name___J4S3N", s = "styles-module__price___W9fic", _ = {
  name: e,
  price: s
};
export {
  _ as default,
  e as name,
  s as price
};
